import { render, staticRenderFns } from "./ServiceItemPortraitLineOne.vue?vue&type=template&id=a40f8bb8&scoped=true&"
import script from "./ServiceItemPortraitLineOne.vue?vue&type=script&lang=js&"
export * from "./ServiceItemPortraitLineOne.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemPortraitLineOne.vue?vue&type=style&index=0&id=a40f8bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f8bb8",
  null
  
)

export default component.exports